import { render, staticRenderFns } from "./AnnouncementDuplicate.vue?vue&type=template&id=168bfd27&scoped=true"
import script from "./AnnouncementDuplicate.vue?vue&type=script&lang=js"
export * from "./AnnouncementDuplicate.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDuplicate.vue?vue&type=style&index=0&id=168bfd27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168bfd27",
  null
  
)

export default component.exports